document.addEventListener('DOMContentLoaded', function() {
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  var carousels = document.querySelectorAll('.swiper-container');

  carousels.forEach(function(carousel) {
    var swiper = new Swiper(carousel, {
      navigation: false,
      pagination: {
        el: carousel.querySelector('.swiper-pagination'),
        clickable: false,
      },
      autoplay: false,
      allowTouchMove: isTouchDevice,
    });

    if (!isTouchDevice) {
      // Add mousemove event listener to the carousel
      carousel.addEventListener('mousemove', function(event) {
        var rect = carousel.getBoundingClientRect();
        var xPos = event.clientX - rect.left;
        var width = rect.width;

        var percentage = xPos / width;

        var totalSlides = swiper.slides.length;
        var slideIndex = Math.floor(percentage * totalSlides);

        // Ensure index is within bounds
        slideIndex = Math.max(0, Math.min(slideIndex, totalSlides - 1));

        if (swiper.activeIndex !== slideIndex) {
          swiper.slideTo(slideIndex);
        }
      });
    }
  });
});